import { render, staticRenderFns } from "./__ProductInfo.vue?vue&type=template&id=68aa4c8e&"
import script from "./__ProductInfo.vue?vue&type=script&lang=js&"
export * from "./__ProductInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports